export const sidebarConstant = {
    GET_EMPLOYEE_PERMISSION_SUCCESS: 'app/sidebar/GET_EMPLOYEE_PERMISSION_SUCCESS'
}